module.exports = __webpack_public_path__ + "static/media/insect(22).fad6266b.PNG";